import { c as _c } from "react/compiler-runtime";
import type { Route } from "next";
import Link from "next/link";
import Button from "@/components/button";
import Icon from "@/components/icon";
import { useModalStore } from "@/stores/modal-store";
interface FormActionsProps {
  cancelHref?: string;
  submitLabel?: string;
  submittingLabel?: string;
  cancelLabel?: string;
  isPending: boolean;
  style?: React.CSSProperties;
  closeModal?: () => void;
  handleDelete?: () => void;
  success?: boolean;
}
export const CtaTestimony: React.FC<FormActionsProps> = t0 => {
  const $ = _c(18);
  const {
    cancelHref,
    submitLabel: t1,
    cancelLabel: t2,
    isPending,
    style,
    success,
    handleDelete
  } = t0;
  const submitLabel = t1 === undefined ? "Valider" : t1;
  const cancelLabel = t2 === undefined ? "Annuler" : t2;
  const {
    close
  } = useModalStore();
  let t3;
  if ($[0] !== close) {
    t3 = () => {
      close();
    };
    $[0] = close;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClose = t3;
  let t4;
  if ($[2] !== cancelHref || $[3] !== cancelLabel || $[4] !== handleClose || $[5] !== isPending || $[6] !== style) {
    t4 = cancelHref ? <Link href={cancelHref as Route} className="w-1/3"><Button variant="unfilled" colorTheme="secondary" className="w-full flex items-center justify-center px-4 py-2" disabled={isPending} style={style}>{cancelLabel}</Button></Link> : cancelLabel === "hidden" ? <></> : <Button variant="unfilled" colorTheme="secondary" className="w-1/4 flex items-center justify-center px-4 py-2 border-1" disabled={isPending} style={style} onClick={handleClose}>{cancelLabel}</Button>;
    $[2] = cancelHref;
    $[3] = cancelLabel;
    $[4] = handleClose;
    $[5] = isPending;
    $[6] = style;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isPending || success;
  let t6;
  if ($[8] !== isPending || $[9] !== submitLabel) {
    t6 = isPending ? <Icon icon="time" className="animate-spin" size={24} /> : submitLabel;
    $[8] = isPending;
    $[9] = submitLabel;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleDelete || $[12] !== t5 || $[13] !== t6) {
    t7 = <Button type="submit" className="flex items-center justify-center px-4 py-2 w-1/4" disabled={t5} onClick={handleDelete}>{t6}</Button>;
    $[11] = handleDelete;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t4 || $[16] !== t7) {
    t8 = <><div className="flex gap-4 justify-center mt-4 mb-4">{t4}{t7}</div></>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};